"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get genPgAggregateQuery () {
        return genPgAggregateQuery;
    },
    get replaceDelimitedWithKeyValuePg () {
        return replaceDelimitedWithKeyValuePg;
    }
});
const _nocodbsdk = require("nocodb-sdk");
function genPgAggregateQuery({ column, baseModelSqlv2, aggregation, column_query, parsedFormulaType, aggType, alias }) {
    let aggregationSql;
    const { dbDriver: knex } = baseModelSqlv2;
    let condnValue = "''";
    if ([
        _nocodbsdk.UITypes.CreatedTime,
        _nocodbsdk.UITypes.LastModifiedTime,
        _nocodbsdk.UITypes.Date,
        _nocodbsdk.UITypes.DateTime,
        _nocodbsdk.UITypes.Number,
        _nocodbsdk.UITypes.Decimal,
        _nocodbsdk.UITypes.Year,
        _nocodbsdk.UITypes.Currency,
        _nocodbsdk.UITypes.Duration,
        _nocodbsdk.UITypes.Time,
        _nocodbsdk.UITypes.Percent,
        _nocodbsdk.UITypes.Rollup,
        _nocodbsdk.UITypes.Links,
        _nocodbsdk.UITypes.ID
    ].includes(column.uidt) || [
        _nocodbsdk.FormulaDataTypes.DATE,
        _nocodbsdk.FormulaDataTypes.NUMERIC
    ].includes(parsedFormulaType)) {
        condnValue = 'NULL';
    } else if ([
        _nocodbsdk.UITypes.Rating
    ].includes(column.uidt)) {
        condnValue = 0;
    }
    if (aggType === 'common') {
        switch(aggregation){
            case _nocodbsdk.CommonAggregations.Count:
                aggregationSql = knex.raw(`COUNT(*)`);
                break;
            case _nocodbsdk.CommonAggregations.CountEmpty:
                if ([
                    _nocodbsdk.UITypes.JSON
                ].includes(column.uidt)) {
                    aggregationSql = knex.raw(`COUNT(*) FILTER (WHERE (??) IS NULL)`, [
                        column_query
                    ]);
                    break;
                }
                aggregationSql = knex.raw(`COUNT(*) FILTER (WHERE (??) IS NULL OR (??) = ${condnValue})`, [
                    column_query,
                    column_query
                ]);
                break;
            case _nocodbsdk.CommonAggregations.CountFilled:
                // The condition IS NOT NULL AND (column_query) != 'NULL' is not same for the following column_query types:
                // Hence we need to handle them separately.
                if ([
                    _nocodbsdk.UITypes.CreatedTime,
                    _nocodbsdk.UITypes.LastModifiedTime,
                    _nocodbsdk.UITypes.Date,
                    _nocodbsdk.UITypes.DateTime,
                    _nocodbsdk.UITypes.Number,
                    _nocodbsdk.UITypes.Decimal,
                    _nocodbsdk.UITypes.Year,
                    _nocodbsdk.UITypes.Currency,
                    _nocodbsdk.UITypes.Duration,
                    _nocodbsdk.UITypes.Percent,
                    _nocodbsdk.UITypes.Time,
                    _nocodbsdk.UITypes.JSON,
                    _nocodbsdk.UITypes.Rollup,
                    _nocodbsdk.UITypes.Links,
                    _nocodbsdk.UITypes.ID,
                    _nocodbsdk.UITypes.LinkToAnotherRecord,
                    _nocodbsdk.UITypes.Lookup
                ].includes(column.uidt) || [
                    _nocodbsdk.FormulaDataTypes.DATE,
                    _nocodbsdk.FormulaDataTypes.NUMERIC
                ].includes(parsedFormulaType)) {
                    aggregationSql = knex.raw(`COUNT(*) FILTER (WHERE (??) IS NOT NULL)`, [
                        column_query
                    ]);
                    break;
                }
                // For other column_query types, the condition is IS NOT NULL AND (column_query) != 'NULL'
                aggregationSql = knex.raw(`COUNT(*) FILTER (WHERE (??) IS NOT NULL AND (??) != ${condnValue})`, [
                    column_query,
                    column_query
                ]);
                break;
            case _nocodbsdk.CommonAggregations.CountUnique:
                // JSON Does not support DISTINCT for json column_query type. Hence we need to cast the column_query to text.
                if ([
                    _nocodbsdk.UITypes.JSON
                ].includes(column.uidt)) {
                    aggregationSql = knex.raw(`COUNT(DISTINCT ((??)::text)) FILTER (WHERE (??) IS NOT NULL)`, [
                        column_query,
                        column_query
                    ]);
                    break;
                }
                // The condition IS NOT NULL AND (column_query) != 'NULL' is not same for the following column_query types:
                // Hence we need to handle them separately.
                if ([
                    _nocodbsdk.UITypes.CreatedTime,
                    _nocodbsdk.UITypes.LastModifiedTime,
                    _nocodbsdk.UITypes.Date,
                    _nocodbsdk.UITypes.DateTime,
                    _nocodbsdk.UITypes.Number,
                    _nocodbsdk.UITypes.Decimal,
                    _nocodbsdk.UITypes.Year,
                    _nocodbsdk.UITypes.Currency,
                    _nocodbsdk.UITypes.Time,
                    _nocodbsdk.UITypes.Duration,
                    _nocodbsdk.UITypes.Percent,
                    _nocodbsdk.UITypes.Rollup,
                    _nocodbsdk.UITypes.Links,
                    _nocodbsdk.UITypes.ID,
                    _nocodbsdk.UITypes.LinkToAnotherRecord,
                    _nocodbsdk.UITypes.Lookup
                ].includes(column.uidt) || [
                    _nocodbsdk.FormulaDataTypes.DATE,
                    _nocodbsdk.FormulaDataTypes.NUMERIC
                ].includes(parsedFormulaType)) {
                    aggregationSql = knex.raw(`COUNT(DISTINCT (??)) FILTER (WHERE (??) IS NOT NULL)`, [
                        column_query,
                        column_query
                    ]);
                    break;
                }
                aggregationSql = knex.raw(`COUNT(DISTINCT (??)) FILTER (WHERE (??) IS NOT NULL AND (??) != ${condnValue})`, [
                    column_query,
                    column_query,
                    column_query
                ]);
                break;
            case _nocodbsdk.CommonAggregations.PercentEmpty:
                if ([
                    _nocodbsdk.UITypes.JSON
                ].includes(column.uidt)) {
                    aggregationSql = knex.raw(`(COUNT(*) FILTER (WHERE (??) IS NULL) * 100.0 / NULLIF(COUNT(*), 0))`, [
                        column_query
                    ]);
                    break;
                }
                aggregationSql = knex.raw(`(COUNT(*) FILTER (WHERE (??) IS NULL OR (??) = ${condnValue}) * 100.0 / NULLIF(COUNT(*), 0))`, [
                    column_query,
                    column_query
                ]);
                break;
            case _nocodbsdk.CommonAggregations.PercentFilled:
                // The condition IS NOT NULL AND (column_query) != 'NULL' is not same for the following column_query types:
                // Hence we need to handle them separately.
                if ([
                    _nocodbsdk.UITypes.CreatedTime,
                    _nocodbsdk.UITypes.LastModifiedTime,
                    _nocodbsdk.UITypes.Date,
                    _nocodbsdk.UITypes.DateTime,
                    _nocodbsdk.UITypes.Number,
                    _nocodbsdk.UITypes.Time,
                    _nocodbsdk.UITypes.Decimal,
                    _nocodbsdk.UITypes.Year,
                    _nocodbsdk.UITypes.Currency,
                    _nocodbsdk.UITypes.Duration,
                    _nocodbsdk.UITypes.Percent,
                    _nocodbsdk.UITypes.JSON,
                    _nocodbsdk.UITypes.Rollup,
                    _nocodbsdk.UITypes.Links,
                    _nocodbsdk.UITypes.ID,
                    _nocodbsdk.UITypes.LinkToAnotherRecord,
                    _nocodbsdk.UITypes.Lookup
                ].includes(column.uidt) || [
                    _nocodbsdk.FormulaDataTypes.DATE,
                    _nocodbsdk.FormulaDataTypes.NUMERIC
                ].includes(parsedFormulaType)) {
                    aggregationSql = knex.raw(`(COUNT(*) FILTER (WHERE (??) IS NOT NULL) * 100.0 / NULLIF(COUNT(*), 0))`, [
                        column_query
                    ]);
                    break;
                }
                aggregationSql = knex.raw(`(COUNT(*) FILTER (WHERE (??) IS NOT NULL AND (??) != ${condnValue}) * 100.0 / NULLIF(COUNT(*), 0))`, [
                    column_query,
                    column_query
                ]);
                break;
            case _nocodbsdk.CommonAggregations.PercentUnique:
                // JSON Does not support DISTINCT for json column_query type. Hence we need to cast the column_query to text.
                if ([
                    _nocodbsdk.UITypes.JSON
                ].includes(column.uidt)) {
                    aggregationSql = knex.raw(`(COUNT(DISTINCT ((??)::text)) FILTER (WHERE (??) IS NOT NULL) * 100.0 / NULLIF(COUNT(*), 0))`, [
                        column_query,
                        column_query
                    ]);
                    break;
                }
                // The condition IS NOT NULL AND (column_query) != 'NULL' is not same for the following column_query types:
                // Hence we need to handle them separately.
                if ([
                    _nocodbsdk.UITypes.CreatedTime,
                    _nocodbsdk.UITypes.LastModifiedTime,
                    _nocodbsdk.UITypes.Date,
                    _nocodbsdk.UITypes.DateTime,
                    _nocodbsdk.UITypes.Number,
                    _nocodbsdk.UITypes.Decimal,
                    _nocodbsdk.UITypes.Year,
                    _nocodbsdk.UITypes.Time,
                    _nocodbsdk.UITypes.Currency,
                    _nocodbsdk.UITypes.Duration,
                    _nocodbsdk.UITypes.Percent,
                    _nocodbsdk.UITypes.Rollup,
                    _nocodbsdk.UITypes.Links,
                    _nocodbsdk.UITypes.ID,
                    _nocodbsdk.UITypes.LinkToAnotherRecord,
                    _nocodbsdk.UITypes.Lookup
                ].includes(column.uidt) || [
                    _nocodbsdk.FormulaDataTypes.DATE,
                    _nocodbsdk.FormulaDataTypes.NUMERIC
                ].includes(parsedFormulaType)) {
                    aggregationSql = knex.raw(`(COUNT(DISTINCT (??)) FILTER (WHERE (??) IS NOT NULL) * 100.0 / NULLIF(COUNT(*), 0))`, [
                        column_query,
                        column_query
                    ]);
                    break;
                }
                aggregationSql = knex.raw(`(COUNT(DISTINCT (??)) FILTER (WHERE (??) IS NOT NULL AND (??) != ${condnValue}) * 100.0 / NULLIF(COUNT(*), 0))`, [
                    column_query,
                    column_query,
                    column_query
                ]);
                break;
            case _nocodbsdk.CommonAggregations.None:
                break;
        }
    } else if (aggType === 'numerical') {
        switch(aggregation){
            case _nocodbsdk.NumericalAggregations.Avg:
                if (column.uidt === _nocodbsdk.UITypes.Rating) {
                    aggregationSql = knex.raw(`AVG((??)) FILTER (WHERE (??) != ??)`, [
                        column_query,
                        column_query,
                        condnValue
                    ]);
                    break;
                }
                aggregationSql = knex.raw(`AVG((??))`, [
                    column_query
                ]);
                break;
            case _nocodbsdk.NumericalAggregations.Max:
                aggregationSql = knex.raw(`MAX((??))`, [
                    column_query
                ]);
                break;
            case _nocodbsdk.NumericalAggregations.Min:
                if (column.uidt === _nocodbsdk.UITypes.Rating) {
                    aggregationSql = knex.raw(`MIN((??)) FILTER (WHERE (??) != ??)`, [
                        column_query,
                        column_query,
                        condnValue
                    ]);
                    break;
                }
                aggregationSql = knex.raw(`MIN((??))`, [
                    column_query
                ]);
                break;
            case _nocodbsdk.NumericalAggregations.Sum:
                aggregationSql = knex.raw(`SUM((??))`, [
                    column_query
                ]);
                break;
            case _nocodbsdk.NumericalAggregations.StandardDeviation:
                if (column.uidt === _nocodbsdk.UITypes.Rating) {
                    aggregationSql = knex.raw(`stddev_pop((??)) FILTER (WHERE (??) != ??) `, [
                        column_query,
                        column_query,
                        condnValue
                    ]);
                    break;
                }
                aggregationSql = knex.raw(`stddev_pop((??))`, [
                    column_query
                ]);
                break;
            case _nocodbsdk.NumericalAggregations.Range:
                aggregationSql = knex.raw(`MAX((??)) - MIN((??))`, [
                    column_query,
                    column_query
                ]);
                break;
            case _nocodbsdk.NumericalAggregations.Median:
                aggregationSql = knex.raw(`percentile_cont(0.5) within group (order by (??))`, [
                    column_query
                ]);
                break;
            default:
                break;
        }
    } else if (aggType === 'boolean') {
        switch(aggregation){
            case _nocodbsdk.BooleanAggregations.Checked:
                aggregationSql = knex.raw(`COUNT(*) FILTER (WHERE (??) = true)`, [
                    column_query
                ]);
                break;
            case _nocodbsdk.BooleanAggregations.Unchecked:
                aggregationSql = knex.raw(`COUNT(*) FILTER (WHERE (??) = false OR (??) = NULL)`, [
                    column_query,
                    column_query
                ]);
                break;
            case _nocodbsdk.BooleanAggregations.PercentChecked:
                aggregationSql = knex.raw(`(COUNT(*) FILTER (WHERE (??) = true) * 100.0 / NULLIF(COUNT(*), 0))`, [
                    column_query
                ]);
                break;
            case _nocodbsdk.BooleanAggregations.PercentUnchecked:
                aggregationSql = knex.raw(`(COUNT(*) FILTER (WHERE (??) = false OR (??) = NULL) * 100.0 / NULLIF(COUNT(*), 0))`, [
                    column_query,
                    column_query
                ]);
                break;
            default:
                break;
        }
    } else if (aggType === 'date') {
        switch(aggregation){
            case _nocodbsdk.DateAggregations.EarliestDate:
                aggregationSql = knex.raw(`MIN((??))`, [
                    column_query
                ]);
                break;
            case _nocodbsdk.DateAggregations.LatestDate:
                aggregationSql = knex.raw(`MAX((??))`, [
                    column_query
                ]);
                break;
            // The Date, DateTime, CreatedTime, LastModifiedTime columns are casted to DATE.
            case _nocodbsdk.DateAggregations.DateRange:
                aggregationSql = knex.raw(`MAX((??)::date) - MIN((??)::date)`, [
                    column_query,
                    column_query
                ]);
                break;
            // The Date, DateTime, CreatedTime, LastModifiedTime columns are casted to DATE.
            case _nocodbsdk.DateAggregations.MonthRange:
                aggregationSql = knex.raw(`DATE_PART('year', AGE(MAX((??)::date), MIN((??)::date))) * 12 + 
         DATE_PART('month', AGE(MAX((??)::date), MIN((??)::date))) `, [
                    column_query,
                    column_query,
                    column_query,
                    column_query
                ]);
                break;
            default:
                break;
        }
    } else if (aggType === 'attachment') {
        switch(aggregation){
            case _nocodbsdk.AttachmentAggregations.AttachmentSize:
                aggregationSql = knex.raw(`SUM((SELECT COALESCE(SUM((json_object ->> 'size')::int), 0)FROM jsonb_array_elements(??::jsonb) AS json_array(json_object)))`, [
                    column_query
                ]);
                break;
        }
    }
    if (aggregationSql) {
        if (![
            _nocodbsdk.AllAggregations.EarliestDate,
            _nocodbsdk.AllAggregations.LatestDate
        ].includes(aggregation)) {
            aggregationSql = knex.raw(`COALESCE(??, 0)`, [
                aggregationSql
            ]);
        }
        if (alias) {
            aggregationSql = knex.raw(`?? AS ??`, [
                aggregationSql,
                alias
            ]);
        }
    }
    return aggregationSql == null ? void 0 : aggregationSql.toQuery();
}
function replaceDelimitedWithKeyValuePg(params) {
    var _params_delimiter;
    const delimiter = (_params_delimiter = params.delimiter) != null ? _params_delimiter : ',';
    const knex = params.knex;
    if (!params.stack || params.stack.length === 0) {
        return knex.raw(`??`, [
            params.needleColumn
        ]).toQuery();
    }
    // create union replace statement for each user
    const mapUnion = params.stack.map((row)=>{
        return knex.raw(`select ? as nc_p_key, ? as nc_p_value`, [
            row.key,
            row.value
        ]).toQuery();
    }).join(' UNION ALL ');
    const needleAsRows = knex.raw(`select ?? as nc_raw_needle, trim(unnest(string_to_array(??, '${delimiter}'))) as nc_p_needle`, [
        params.needleColumn,
        params.needleColumn
    ]).toQuery();
    const result = knex.raw([
        `select nc_p_result from (`,
        `  select nc_t_needle.nc_raw_needle, string_agg(coalesce(nc_t_stack.nc_p_value, nc_t_stack.nc_p_key), '${delimiter}') as nc_p_result`,
        `  from (${needleAsRows}) nc_t_needle`,
        `  left join (${mapUnion}) nc_t_stack`,
        `    on nc_t_needle.nc_p_needle = nc_t_stack.nc_p_key`,
        `  group by nc_t_needle.nc_raw_needle`,
        `) nc_subquery`
    ].join(' ')).toQuery();
    return result;
}
